module.exports = __webpack_public_path__ + "static/media/img3.82bf4f7b.jpg";